import { TaskRecord } from '../../containers/tasks-table/tasks-table.type';

enum AdherenceLogEventType {
  SKIPPED_STATUS = 'skipped_status',
  MISSED_EVENT = 'missed_event',
  UNEXPECTED_EVENT = 'unexpected_event',
}

type EventAlert = {
  id: string;
  step_id: string;
  event_model: 'task' | 'change_request';
  raw_event_type: string;
  step_mapping_relationship: 'includes' | 'excludes';
  step_mapping_names: string[];
};

type AdherenceLog = {
  id: string;
  task: TaskRecord;
  raw_event: string;
  event_type: AdherenceLogEventType;
  message: string;
  analysis: string;
  changed_at: string;
  changed_by: string;
  from_name: string;
  to_name: string;
};

export { AdherenceLogEventType };
export type { AdherenceLog, EventAlert };
